import { render, staticRenderFns } from "./PrintJournalSettlement.vue?vue&type=template&id=24f596b8"
import script from "./PrintJournalSettlement.vue?vue&type=script&lang=js"
export * from "./PrintJournalSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports